import { useSelector } from 'react-redux';
import {
  selectGeneratedQuestionSet,
  selectIsGenerating,
  selectGeneratedQuestionSetError
} from './redux/selectors';

export const useGeneratedQuestionSet = () => {
  const generatedQuestionSet = useSelector(selectGeneratedQuestionSet);
  const isGenerating = useSelector(selectIsGenerating);
  const generatedQuestionSetError = useSelector(selectGeneratedQuestionSetError);

  return { generatedQuestionSet, isGenerating, generatedQuestionSetError };
};
